var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"center","margin-top":"5%"}},[_c('img',{staticStyle:{"width":"50%"},attrs:{"src":require('@/assets/img/404.png')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }